import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import api from "../../services/api";

const BalanceTab = () => {
    const { id: userId } = useParams();
    const location = useLocation();
    const walletId = location.state?.walletId;
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const fetchUserDetails = async () => {
            if (!userId) return;
            try {
                setLoading(true);
                const idToUse = walletId || userId;
                const response = await api.get(`/admin/user/details/${idToUse}`);
                if (response.data && response.data.success) {
                    setUserData(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching user details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserDetails();
    }, [userId]);

    // Format currency helper
    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === '') return '0.00';
        const numericValue = parseFloat(value || "0");
        return numericValue.toFixed(2);
    };

    if (loading) {
        return <div className="text-white p-4">Loading...</div>;
    }

    const netExposure = formatCurrency(Math.abs(userData?.total_exposure || 0));
    const balanceDown = formatCurrency(userData?.bal_down || 0);
    const balanceUp = formatCurrency(userData?.bal_up || 0);
    const creditLimit = formatCurrency(userData?.creditLimit || 0);
    const availableCredit = formatCurrency(userData?.credit || 0);

    // Determine color for exposure (usually negative is red, but here we show abs value)
    // Logic from previous code: verdict based color? 
    // The previous code used wallet.verdict. 
    // My controller returns verdict.
    const exposureColor = userData?.total_exposure >= 0 ? 'text-green-500' : 'text-red-500';

    return (
        <div className=" w-full mx-auto bg-[#0f1224]  h-auto">
            <div style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }} className="shadow-sm px-3 py-4">
                <div className="w-full mx-auto">

                </div>
                <div style={{ borderColor: '#cae0e8', borderBottomWidth: '1px', borderBottomStyle: 'solid' }} className="mb-2" />
                <div className="space-y-1 w-[20%]">
                    <div className="flex justify-between items-center py-1 px-2 bg-[#252837] mb-1 ">
                        <span className="text-white text-[14px] font-bold">Net Exposure</span>
                        <span className={`text-[14px] font-bold ${exposureColor}`}>
                            {netExposure}
                        </span>
                    </div>
                    <div className="flex justify-between items-center px-2 mb-1 ">
                        <span className="text-white text-[14px] font-bold">Balance Down</span>
                        <span className="text-red-500 text-[14px] font-bold">{balanceDown}</span>
                    </div>
                    <div className="flex justify-between items-center py-1 px-2 bg-[#252837] mb-1 ">
                        <span className="text-white text-[14px] font-bold">Balance Up</span>
                        <span className="text-red-500 text-[14px] font-bold">{balanceUp}</span>
                    </div>
                    <div className="flex justify-between items-center px-2 mb-1 ">
                        <span className="text-white text-[14px] font-bold">Credit Limit</span>
                        <span className="text-red-500 text-[14px] font-bold">{creditLimit}</span>
                    </div>
                    <div className="flex justify-between items-center py-1 px-2 bg-[#252837] mb-1 ">
                        <span className="text-white text-[14px] font-bold">Available Credit</span>
                        <span className="text-white text-[14px] font-bold">{availableCredit}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BalanceTab;

